import { createEvent, sample } from 'effector'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'
import { fx } from 'src/libs'
import {
  STATUS_OWNER_BE,
  STATUS_THIRD_PARTY,
  STATUS_THIRD_PARTY_BE,
} from 'src/pages/billing/withdrawals/atoms/EditOwnerTypeModal/const'
import {
  findPurse,
  updatePurseList,
} from 'src/pages/billing/withdrawals/atoms/EditOwnerTypeModal/util'
import { $clientGroupedPurses } from 'src/views/widgets/groupedClientPurses/model'

type SetClassificationPayload = {
  purseId: number
  ownerClassificationStatus: string
}

export const setPurseOwnerClassification =
  createEvent<SetClassificationPayload>()

export const setPurseOwnerClassificationFx = fx<SetClassificationPayload, any>({
  method: 'POST',
})

sample({
  clock: setPurseOwnerClassification,
  fn: ({
    purseId,
    ownerClassificationStatus,
  }: SetClassificationPayload): any => {
    return {
      url: `/client_purse/${purseId}/set_client_purse_owner_classification`,
      body: { ownerClassificationStatus },
      purseId,
    }
  },
  target: setPurseOwnerClassificationFx,
})

sample({
  clock: setPurseOwnerClassificationFx.failData,
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})

sample({
  clock: setPurseOwnerClassificationFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Request success',
    description: 'Owner classification updated successfully',
  }),
  target: showNotification,
})

sample({
  clock: setPurseOwnerClassificationFx.done,
  source: $clientGroupedPurses,
  fn: (clientGroupedPurses, { params }) => {
    const { purseId, body } = params as { body: any; purseId: number }

    const ownerClassificationStatus =
      body.ownerClassificationStatus === STATUS_THIRD_PARTY
        ? STATUS_THIRD_PARTY_BE
        : STATUS_OWNER_BE

    const target = findPurse(clientGroupedPurses, purseId)
    if (!target) {
      return clientGroupedPurses
    }

    const groupId = target.purseGroupId
    return updatePurseList({
      list: clientGroupedPurses,
      purseId,
      groupId,
      ownerClassificationStatus,
    })
  },
  target: $clientGroupedPurses,
})
